// This context is provided by ui-library. This pattern will need to be
// revisited when UIComponents migrated from ui-library to the wpxds sandbox editor.

import { createContext } from 'react';

export interface SandboxContextState {
  sandboxed: boolean;
}

export const defaultSandboxContext: SandboxContextState = { sandboxed: false };

export const SandboxContext = createContext(defaultSandboxContext);

const { Consumer, Provider } = SandboxContext;

export { Provider as SandboxContextProvider };
export { Consumer as SandboxContextConsumer };
